define('lq/events/actions/eventAction',[
    'jquery',
    'lq/oop'
], function ($, oop) {
	'use strict';

	function EventAction(eventData, eventArg) {
	    this.eventData = eventData;
	    this.eventArg = eventArg;
	}

    oop.makeExtendable(EventAction);

    EventAction.DO_NOT_BATCH = "no-batch";
    EventAction.QUERY_BATCH = "query-batch";
    EventAction.COMMAND_BATCH = "command-batch";

    EventAction.prototype.getBatchType = function () {
        throw new Error('please override \'getBatchType()\' of EventAction');
    };

    EventAction.prototype.createEventActionRequest = function () {
        return undefined;
    };

    EventAction.prototype.execute = function (continuation, eventActionResponse) {
        continuation();
    };

    EventAction.prototype.eventIsEnabled = function (eventName) {
        return this.eventData.eventing && this.eventData.eventing[eventName] && this.eventData.eventing[eventName].enabled;
    };

    EventAction.prototype.triggerEvent = function (eventName, next, param) {
        this.piping.eventing.publish(this.eventData.eventing[eventName].raisedEventName, this.eventSource, param, next, this.getEventActionIdentifier(), this.abortion);
    };

    EventAction.prototype.getEventActionIdentifier = function (eventName, next, param) {
        return {
            id: this.eventActionId,
            actionInstanceId: this.rootDrop.instanceId
        };
    };

    EventAction.prototype.triggerEventIfEnabled = function (eventName, next, param) {
        if (this.eventIsEnabled(eventName)) {
            this.triggerEvent(eventName, next, param);
        }
    };

    EventAction.prototype.triggerEventIfEnabledAndContinue = function (eventName, next, param) {
        if (this.eventIsEnabled(eventName)) {
            this.triggerEvent(eventName, next, param);
        }
        else {
            next();
        }
    };

    EventAction.prototype.handleExecutionTrailDirty = function (continuation) {
        if (this.eventIsEnabled("onExecutionTrailDirty")) {
            this.triggerEvent("onExecutionTrailDirty", function () {
                continuation({ break: true });
            });
        } else {
            alert("Could not create report, because the data is dirty.");
            continuation({ break: true });
        }
    };

    return EventAction;
});
